import { SectionShell } from "@/components/dash/primitives";

export default function Operations({ data, num, title }) {
  if (!data || !Array.isArray(data.groups) || data.groups.length === 0) return null;
  return (
    <SectionShell id="operations" num={num} title={title}>
      {data.intro && (
        <p className="text-slate-700 leading-relaxed mb-8 max-w-3xl">{data.intro}</p>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="operations-groups">
        {data.groups.map((g, gi) => (
          <div
            key={gi}
            data-testid={`operations-group-${gi + 1}`}
            className="bg-white border border-slate-200 rounded-xl p-6 transition-all duration-300 hover:shadow-md hover:border-slate-300"
          >
            <h3 className="font-num text-xs uppercase tracking-[0.18em] text-orange-600 mb-4">{g.title}</h3>
            <ul className="space-y-3">
              {(g.items || []).map((it, ii) => (
                <li key={ii} className="text-sm leading-relaxed">
                  {it.label && <span className="font-semibold text-slate-900">{it.label}: </span>}
                  <span className="text-slate-600">{it.text}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {data.note && <p className="text-xs text-slate-500 mt-6 leading-relaxed max-w-3xl">{data.note}</p>}
    </SectionShell>
  );
}
